import {API_VERSION} from '@/utils/constants/commonConstants';
import {HTTP_METHODS} from '@/utils/constants/httpMethods';
import {buildQueryParams} from '@/utils/commons';

export const PRODUCTS_CONFIG = {
  PRODUCT_LIST: (queryParams) => ({
    endPoint: `product?${buildQueryParams(queryParams)}`,
    // mockData: ProductListData,
    method: HTTP_METHODS.POST,
    version: API_VERSION.V1
  }),
  PRODUCT_CSV_DOWNLOAD: (queryParams) => ({
    endPoint: `product/download?${buildQueryParams(queryParams)}`,
    method: HTTP_METHODS.POST,
    baseUrlKey: 'inventoryApiUrl' // Dynamically use INVENTORY_API_URL
  })
};
